import React from 'react';
import { FAIcon } from '~/components/utils/FAIcons';

type FileLoadingIndicatorProps = {
	description?: string;
};

const FileLoadingIndicator = ({ description }: FileLoadingIndicatorProps) => {
	return (
		<div className="p-2 rounded-lg border border-2 animate-pulse flex justify-items-stretch items-center">
			<div className="px-3 py-1 mr-2 rounded-md bg-gray-200">
				<FAIcon icon="file" className=" text-4xl" />
			</div>

			<div className="ml-2 flex-1">
				<p className="font-medium text-md -mb-0.5">Loading...</p>
				{description && <p className="text-gray-400">{description}</p>}
			</div>
			<div className="py-1 px-1 cursor-pointer">
				<FAIcon icon="trash" className="text-red-400 text-3xl" />
			</div>
		</div>
	);
};

export default FileLoadingIndicator;
